import { locationIdFormat } from "@redotech/redo-model/ids";
import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import { PickSessionStrategy } from "@redotech/redo-model/wms/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const createPickSession = {
  name: "createPickSession" as const,
  input: z.object({
    numberOfGroups: z.number().int().min(1).max(100),
    searchInput: AdvancedFilterInputSchema,
    locationId: locationIdFormat.schema,
    strategy: createEnum(PickSessionStrategy),
    seedGroupId: zExt.objectId().nullish(),
    assignedUserId: zExt.objectId().optional(),
    toteIds: z.array(zExt.objectId()).optional(),
    pollForOpenSearchChanges: z.boolean().optional(),
    filterName: z.string().nullish(),
    useIncremental: z.boolean().optional(),
    useBatchCommit: z.boolean().optional(),
  }),
  output: z.object({
    pickSessionId: zExt.objectId().optional(),
    rejectedGroups: z
      .array(
        z.object({
          groupId: zExt.objectId(),
          orderNames: z.array(z.string()),
          reason: z.string(),
          productSku: z.string().optional(),
          productVariantTitle: z.string().optional(),
          productImageUrl: z.string().optional(),
        }),
      )
      .optional(),
  }),
};
